import styled from "styled-components";

import Button from "@atoms/Button/Button";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99; // Toast가 100이라서 99로 설정
  background: rgba(0, 0, 0, 0.7);
`;

export const SaveToDBModalWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 56rem;
  transform: translate(-50%, -50%);
  border-radius: 2rem;
  background: linear-gradient(#ffffff, #ffffff),
    ${({ theme }) => theme.color.gradient.background1};
  background-origin: padding-box, border-box;
  background-clip: padding-box, border-box;
  box-shadow: 0 0.4rem 0.8rem rgba(7, 68, 162, 0.02);
  padding: 3.2rem 4rem;
`;

export const SaveToDBModalCloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 12px;
  height: 12px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const SaveToDBModalContents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2.4rem;
  width: 100%;
`;

export const SaveToDBModalTitle = styled.h3`
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.color.neural.gray10};
`;

export const SaveToDBModalText = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.96rem;
  color: ${({ theme }) => theme.color.neural.gray09};
  margin-bottom: 2.4rem;

  & strong {
    font-weight: 700;
  }
`;

export const SaveToDBModalButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.4rem;
  width: 100%;

  & > button {
    width: 100%;
    gap: 0.8rem;
    padding: 0;
  }
`;

export const CancelButton = styled.button`
  width: 100%;
  font-weight: 600;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// NOTE : 기사 발행이 불가한 경우의 Disabled 상태는 디자인 시안(Bg #cbd0d8 / Text #96a1b0)을 따릅니다.
export const EditArticleButton = styled(Button)`
  &:disabled {
    opacity: 1;
    background-color: #cbd0d8;
    color: #96a1b0;
    border: 0.1rem solid #cbd0d8;
  }
`;
